import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change: if there's a hash (#friction-audit), scroll to it once it renders.
 * Otherwise, scroll to top instantly.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Auth fragments like #session_id=… are not page anchors — leave them for the OAuth callback.
    if (hash && !hash.includes("=")) {
      // wait one frame for the target section to mount
      const t = setTimeout(() => {
        const el = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(t);
    }
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
